import React, { useState } from 'react'
import firebase from "firebase/app"
import mobiscroll from '@mobiscroll/react'
import "firebase/auth"
import { auth } from './index'

const Auth = ({ theme }) => {

    const [wait, setWait] = useState(false)
    const bg = theme === 'dark' ? 'bg-dark' : 'bg-white'

    const signIn = () => {
        setWait(true)
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider)
            .then((result) => {
                setWait(false)
                /** @type {firebase.auth.OAuthCredential} */
                //var credential = result.credential;
                // This gives you a Google Access Token. You can use it to access the Google API.
                //const token = credential.accessToken;
                // The signed-in user info.
                //const user = result.user;
            }).catch((error) => {
                setWait(false)
                // Handle Errors here.
                // var errorCode = error.code;
                // var errorMessage = error.message;
                // The email of the user's account used.
                //var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                //var credential = error.credential;
                // ...
            })
    }

    const skip = () => {
        auth.signInAnonymously()
            .then(() => {
                // Signed in..
            })
            .catch((error) => {
                //var errorCode = error.code;
                //var errorMessage = error.message;
                // ...
            })
    }
    return (
        <div className={'container text-center ' + bg} style={{ height: '100vh' }}>
            <div className="w-100" style={{ height: '30vh' }}></div>
            <img className="mb-6" src="/logo192.png" style={{ height: 128, width: 128 }} alt="logo" />
            <div className="w-100" style={{ height: '5vh' }}></div>
            {wait ?
                <div className="m-4 alert alert-light d-flex justify-content-center">
                    等待Google驗證...
                </div> :
                <div className="m-4">
                    <mobiscroll.Button onClick={signIn} className="mt md-social-btn mbsc-btn-block" style={{ background: '#d34230', color: '#fff' }}>
                        <span className="mbsc-ic mbsc-ic-fa-google mbsc-pull-left"></span>
                                Log in with Google
                            </mobiscroll.Button>
                    <div className="w-100 text-center text-muted">登入後資料可轉移至其他裝置<br/>且不會因刪除App導致紀錄消失</div>
                </div>
            }
            <button className="btn btn-link mt-4" onClick={skip}>略過</button>
        </div>
    )
}

export default Auth